// Rich text editor configuration constants
export const DEFAULT_RICH_TEXT_PLUGINS = 'link lists';
export const DEFAULT_RICH_TEXT_TOOLBAR = [
  'styleselect | bold italic link unlink | forecolor backcolor | alignleft aligncenter alignright | bullist numlist | removeformat',
];

// Email provider constants
export const EMAIL_PROVIDER_GMAIL = 'gmail' as const;
export const EMAIL_PROVIDER_OUTLOOK = 'outlook' as const;

// Email provider type
export type EmailProvider = typeof EMAIL_PROVIDER_GMAIL | typeof EMAIL_PROVIDER_OUTLOOK;

// Platform integration type constants for email providers
export const EMAIL_INTEGRATION_TYPE_GMAIL = 'googlegmail' as const;
export const EMAIL_INTEGRATION_TYPE_OUTLOOK = 'microsoftoutlook' as const;

// Email integration type
export type EmailIntegrationType = typeof EMAIL_INTEGRATION_TYPE_GMAIL | typeof EMAIL_INTEGRATION_TYPE_OUTLOOK;

